"use client"
import dynamic from 'next/dynamic'
import PropertyCardSkeleton from '@/screens/dashboard/skeleton-ui/PropertyCard'
import PropertyCard from '@/screens/dashboard/ui/PropertyCard'
import { useState } from 'react'
const CustomSwiper = dynamic(() => import('@/components/custom-swiper'), {
  ssr: false,
})

export const PropertiesSliderSkeletonFor = () => {
  return (
    <>
      <div className='hidden md:flex flex-wrap gap-x-7 gap-y-5 justify-between'>
        {Array.from({ length: 8 }).map((_, i) => (
          <PropertyCardSkeleton
            loading={true}
            key={i}
            width='max-w-[290px]'
          />
        ))}
      </div>
      <div className='md:hidden rounded-xl overflow-hidden'>
        <CustomSwiper
          autoplay={false}
          showDots={false}
          touchEnabled={true}
          slidesToShow={1.25}
          speed={250}
          infinite={false}
          className='w-full h-full'
        >
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={i}
              className='min-h-[440px] rounded-xl overflow-hidden pr-4'
            >
              <PropertyCardSkeleton width='max-w-[289px] max-h-[289px]' />
            </div>
          ))}
        </CustomSwiper>
      </div>
    </>
  )
}

export const PropertiesSliderForMobile = ({ properties = [] }) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  return (
    <>
      {properties?.data?.length ? (
        <CustomSwiper
          autoplay={false}
          showDots={false}
          touchEnabled={true}
          slidesToShow={1.25}
          showPrevious={true}
          onSlideChange={setCurrentSlide}
          infinite={false}
          className='w-full h-full'
        >
          {properties?.data?.map((property, i) => (
            <div key={i} className='h-full rounded-xl overflow-hidden pr-4'>
              <PropertyCard
                className='w-full max-w-[290px]'
                property={property}
                isFullyVisible={i === currentSlide}
                ishome={true}
                // enableTouch={true}
              />
            </div>
          ))}
        </CustomSwiper>
      ) : (
        <p className='text-sm font-semibold mb-4 h-[50vh]'>
          Property Not Available
        </p>
      )}
    </>
  )
}
